import { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { fetchSuiteWalkThroughs } from 'src/services/client';

export interface IWalkthroughSchedule {
  scheduledAt: string | null;
  scheduledDay: string | null;
  scheduledTime: string | null;
}

export interface IWalkthroughRow {
  id: string;
  walkthroughName: string;
  walkthroughType: string;
  status: string;
  permissions: string | null;
  description: string | null;
  serviceRequestCount: number;
  pdfurl: string | null;
  completedDate: string | null;
  schedule: IWalkthroughSchedule | null;

  calcomBookingUid: string | null;
  startTime: string | null;
}

interface IWalkthroughsResponse {
  statusCode: number;
  message: string;
  data: IWalkthroughRow[];
}

export const useSuiteWalkthroughs = (suiteId: string, roleName: string) => {
  const [walkthroughs, setWalkthroughs] = useState<IWalkthroughRow[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<null | string>(null);

  const loadWalkthroughs = useCallback(async () => {
    if (!suiteId || !roleName) return;

    setIsLoading(true);
    setError(null);

    try {
      const response: any = await fetchSuiteWalkThroughs(suiteId, roleName);

      if (response.status === 200 && response.ok) {
        const result: IWalkthroughsResponse = await response.json();
        setWalkthroughs(result.data || []);
      } else {
        throw new Error('Failed to fetch walkthroughs');
      }
    } catch (err) {
      const message = '🚫 Something went wrong, please try again.';
      setError(message);
      setWalkthroughs([]);
      toast.error(message, { autoClose: 3000, position: 'top-center' });
    } finally {
      setIsLoading(false);
    }
  }, [suiteId, roleName]);

  useEffect(() => {
    loadWalkthroughs();
  }, [loadWalkthroughs]);

  return { walkthroughs, isLoading, error, refetch: loadWalkthroughs };
};
